export default [
  //#region  任务池
  {
    name: "task",
    title: "任务池",
    navi: true,
    stage: "task",
    route: {
      path: "/task",
      meta: {
        validation: true,
        permissionOn: true,
        permissions: {
          stageTask: [],
        },
        stage: "task",
      },
      redirect: { name: "task_pool" },
      component: () => import(/* webpackChunkName: "pages-audit" */ "../pages/commons/Layout.vue"),
    },
    children: [
      //任务池
      {
        name: "task_pool",
        title: "任务池",
        navi: true,
        route: {
          path: "pool",
          meta: {
            title: "任务池",
          },
          component: () => import(/* webpackChunkName: "pages-product1" */ "../pages/task/pool.vue"),
        },
      },
      //任务池-完成情况
      {
        name: "task_completion",
        title: "完成情况",
        navi: true,
        route: {
          path: "completion",
          meta: {
            title: "完成情况",
          },
          component: () => import(/* webpackChunkName: "pages-product1" */ "../pages/task/completion.vue"),
        },
      },
    ],
  },
  //#endregion

  {
    name: "stages",
    title: "应用场景",
    navi: {
      shown: true,
    },
    stage: "stages",
    // route: {
    //   path: "/",
    //   meta: {
    //     validation: true,
    //     permissionOn: true,
    //     permissions: {
    //       stageList: [],
    //     },
    //   },
    //   redirect: defaultRoute,
    //   component: () => import(/* webpackChunkName: "pages" */ "../pages/commons/Whiteboard.vue"),
    // },
    children: [

      //#region 榜单管理
      {
        name: "product1",
        title: "CSR调研",
        stage: "product1",
        navi: true,
        route: {
          path: "/",
          meta: {
            validation: true,
            permissionOn: true,
            permissions: {
              stageList: [],
            },
            stage: "product1",
          },
          redirect: { name: "target" },
          component: () => import(/* webpackChunkName: "pages-audit" */ "../pages/commons/Layout.vue"),
        },
        children: [
          //#region  基础管理
          {
            name: "basic",
            title: "基础管理",
            navi: true,
            children: [
              //#region  指标管理
              {
                name: "target",
                title: "指标管理",
                navi: true,
                route: {
                  path: "/target",
                  meta: {
                    permissionOn: true,
                    permissions: {
                      target: [],
                    },
                  },
                  component: () => import(/* webpackChunkName: "pages-product1" */ "../pages/product1/target.vue"),
                },
                children: [
                  {
                    name: "target_edit",
                    title: "指标详情",
                    detail: true,
                    navi: {shown:false},
                    route: {
                      parentName: "product1",
                      path: "/target/detail/:year-:industryId-:secondTargetNum",
                      meta: {
                        permissionOn: true,
                        permissions: {
                          target: [],
                        },
                      },
                      component: () => import(/* webpackChunkName: "pages-product1" */ "../pages/product1/targetDetail.vue"),
                    },
                  },
                  {
                    name: "target_create",
                    title: "指标详情",
                    detail: true,
                    navi: {shown:false},
                    route: {
                      parentName: "product1",
                      path: "target/detail/",
                      meta: {
                        permissionOn: true,
                        permissions: {
                          target: [],
                        },
                      },
                      component: () => import(/* webpackChunkName: "pages-product1" */ "../pages/product1/targetDetail.vue"),
                    },
                  },
                ],
              },
              //#endregion

              //#region  公司管理
              {
                name: "company",
                title: "公司管理",
                navi: true,
                route: {
                  path: "/company",
                  meta: {
                    permissionOn: true,
                    permissions: {
                      company: [],
                    },
                  },
                  component: () => import(/* webpackChunkName: "pages-product1" */ "../pages/product1/company.vue"),
                },
                children: [
                  {
                    name: "company_detail",
                    title: "公司详情",
                    detail: true,
                    navi: {shown:false},
                    route: {
                      parentName: "product1",
                      path: "/company/detail/:stockCode?",
                      meta: {
                        permissionOn: true,
                        permissions: {
                          company: [],
                        },
                      },
                      component: () => import(/* webpackChunkName: "pages-product1" */ "../pages/product1/companyDetail.vue"),
                    },
                  },
                ],
              },
              //#endregion

              {
                name: "company_vote",
                title: "一票否决公司管理",
                navi: true,
                route: {
                  path: "/company/vote",
                  meta: {
                    permissionOn: true,
                    permissions: {
                      companyVote: [],
                    },
                  },
                  component: () => import(/* webpackChunkName: "pages-product1" */ "../pages/product1/company/companyVote.vue"),
                },
              },
            ],
          },
          //#endregion

          //#region  报告库
          {
            name: "report",
            title: "报告库",
            navi: true,
            route: {
              path: "/report",
              meta: {
                permissionOn: true,
                permissions: {
                  report: [],
                },
              },
              component: () => import(/* webpackChunkName: "pages-product1" */ "../pages/product1/report.vue"),
            },
          },
          //#endregion

          //#region  数据录入
          {
            name: "+targetData",
            title: "数据录入",
            navi: true,
            children: [
              {
                name: "targetData_index",
                title: "录入概况",
                navi: true,
                route: {
                  path: "/targetData/index",
                  meta: {
                    permissions: {
                      yearReportData: [],
                    },
                  },
                  component: () => import(/* webpackChunkName: "pages-product1" */ "../pages/product1/targetData/index.vue"),
                },
              },
              {
                name: "targetData_input",
                title: "报告录入",
                navi: true,
                route: {
                  path: "/targetData/input",
                  meta: {
                    permissionOn: true,
                    permissions: {
                      yearReportData: [],
                    },
                  },
                  component: () => import(/* webpackChunkName: "pages-product1" */ "../pages/product1/targetData/input.vue"),
                },
              },
              {
                name: "targetData_import",
                title: "数据导入",
                navi: true,
                route: {
                  path: "/targetData/import",
                  meta: {
                    permissionOn: true,
                    permissions: {
                      importData: [],
                    },
                  },
                  component: () => import(/* webpackChunkName: "pages-product1" */ "../pages/product1/targetData/import.vue"),
                },
              },
            ],
          },
          //#endregion

          //#region  数据管理
          {
            name: "targetData_manager",
            title: "数据管理",
            navi: true,
            route: {
              path: "/targetData/manager",
              meta: {
                permissionOn: true,
                permissions: {
                  targetData: [],
                },
              },
              component: () => import(/* webpackChunkName: "pages-product1" */ "../pages/product1/targetData/manager.vue"),
            },
            children: [],
          },
          //#endregion

          //#region  不合规行为
          {
            name: "+sentiment_behavior",
            title: "不合规行为",
            navi: true,
            children: [
              {
                name: "sentiment_behavior",
                title: "负面行为",
                navi: true,
                route: {
                  path: "/sentiment/behavior",
                  meta: {
                    permissionOn: true,
                    permissions: {
                      publicSentiment: [],
                    },
                  },
                  component: () => import(/* webpackChunkName: "pages-product1" */ "../pages/product1/sentiment/behavior.vue"),
                },
                children: [],
              },
              {
                name: "sentiment_analysis",
                title: "负面行为分析",
                navi: true,
                route: {
                  path: "/sentiment/analysis",
                  meta: {
                    permissionOn: true,
                    permissions: {
                      publicSentiment: [],
                    },
                  },
                  component: () => import(/* webpackChunkName: "pages-product1" */ "../pages/product1/sentiment/result.vue"),
                }
              },
            ],
          },
          //#endregion

          //#region  数据结果
          {
            name: "+result",
            title: "数据结果",
            navi: true,
            children: [
              {
                name: "result_ranking",
                title: "排行榜",
                navi: true,
                route: {
                  path: "/result/ranking",
                  meta: {
                    permissionOn: true,
                    permissions: {
                      csrScore: [],
                    },
                  },
                  component: () => import(/* webpackChunkName: "pages-product1" */ "../pages/product1/result/ranking.vue"),
                },
              },
              {
                name: "result_firstTarget",
                title: "一级指标得分",
                navi: true,
                route: {
                  path: "/result/firstTarget",
                  meta: {
                    permissionOn: true,
                    permissions: {
                      csrScore: [],
                    },
                  },
                  component: () => import(/* webpackChunkName: "pages-product1" */ "../pages/product1/result/firstTarget.vue"),
                },
              },
              {
                name: "result_history",
                title: "历史得分",
                navi: true,
                route: {
                  path: "/result/history",
                  meta: {
                    permissionOn: true,
                    permissions: {
                      csrScore: [],
                    },
                  },
                  component: () => import(/* webpackChunkName: "pages-product1" */ "../pages/product1/result/history.vue"),
                },
              },
            ],
          },
          //#endregion
        ],
      },
      //#endregion

      //#region 舆情管理
      {
        name: "product2",
        title: "上市公司ESG舆情风险",
        stage: "product2",
        navi: true,
        route: {
          path: "/market",
          meta: {
            validation: true,
            permissionOn: true,
            permissions: {
              stageListedSentiment: [],
            },
            stage: "product2",
          },
          redirect: { name: "market_lc_result_tendency" },
          component: () => import(/* webpackChunkName: "pages-audit" */ "../pages/commons/Layout.vue"),
        },
        children: [
          //#region  负面舆情走势
          {
            name: "market_lc_result_tendency",
            title: "负面舆情走势",
            navi: true,
            route: {
              path: "/market/lc/result/tendency",
              meta: {
                permissionOn: true,
                permissions: {
                  lcResult: [],
                },
              },
              component: () => import(/* webpackChunkName: "pages-product2" */ "../pages/product2/lc_result/tendency.vue"),
            },
          },
          //#endregion

          //#region  基础管理
          {
            name: "market_basic",
            title: "基础管理",
            navi: true,
            children: [
              // {
              //   name: "market_target",
              //   title: "指标管理",
              //   navi: true,
              //   route: {
              //     path: "/market/target",
              //     meta: {
              //       permissionOn: true,
              //       permissions: {
              //         listedTarget: [],
              //       },
              //     },
              //     component: () => import(/* webpackChunkName: "pages-product2" */ "../pages/product2/target.vue"),
              //   },
              // },
              // {
              //   name: "market_company",
              //   title: "公司管理",
              //   navi: true,
              //   route: {
              //     path: "/market/company",
              //     meta: {
              //       permissionOn: true,
              //       permissions: {
              //         listedCompany: [],
              //       },
              //     },
              //     component: () => import(/* webpackChunkName: "pages-product2" */ "../pages/product2/company.vue"),
              //   },
              // },

              //#region  指标管理
              {
                name: "market_target",
                title: "指标管理",
                navi: true,
                route: {
                  path: "/market/target",
                  meta: {
                    permissionOn: true,
                    permissions: {
                      listedTarget: [],
                    },
                  },
                  component: () => import(/* webpackChunkName: "pages-product2" */ "../pages/product2/target/ListedTarget.vue"),
                },
                children: [
                  {
                    name: "market_target_detail",
                    title: "指标详情",
                    detail: true,
                    navi: {shown:false},
                    route: {
                      parentName: "product2",
                      path: "/market/target/detail/:thirdTargetNum?",
                      meta: {
                        permissionOn: true,
                        permissions: {
                          target: [],
                        },
                      },
                      component: () => import(/* webpackChunkName: "pages-product1" */ "../pages/product2/target/ListedTargetDetail.vue"),
                    },
                  },
                ]
              },
              //#endregion

              //#region  公司管理
              {
                name: "market_company",
                title: "公司管理",
                navi: true,
                route: {
                  path: "/market/company",
                  meta: {
                    permissionOn: true,
                    permissions: {
                      listedCompany: [],
                    },
                  },
                  component: () => import(/* webpackChunkName: "pages-product1" */ "../pages/product1/company.vue"),
                },
                children: [
                  {
                    name: "market_company_detail",
                    title: "公司详情",
                    detail: true,
                    navi: {shown:false},
                    route: {
                      parentName: "product2",
                      path: "/market/company/detail/:stockCode?",
                      meta: {
                        permissionOn: true,
                        permissions: {
                          listedCompany: [],
                        },
                      },
                      component: () => import(/* webpackChunkName: "pages-product1" */ "../pages/product2/companyDetail.vue"),
                    },
                  },
                ],
              },
              //#endregion
            ],
          },
          //#endregion

          //#region  ESG素材
          {
            name: "esg_material",
            title: "ESG素材",
            navi: true,
            children: [
              {
                name: "market_sentiment_input",
                title: "社会舆情",
                navi: true,
                route: {
                  path: "/market/sentiment/input",
                  meta: {
                    permissionOn: true,
                    permissions: {
                      listedSentiment: [],
                    },
                  },
                  component: () => import(/* webpackChunkName: "pages-product2" */ "../pages/product2/sentiment/input.vue"),
                },
              },
              {
                name: "market_punishment",
                title: "行政处罚",
                navi: true,
                route: {
                  path: "/market/punishment/",
                  meta: {
                    permissionOn: true,
                    permissions: {
                      listedPunishment: [],
                    },
                  },
                  component: () => import(/* webpackChunkName: "pages-product2" */ "../pages/product2/punishment/index.vue"),
                },
              },
            ],
          },
          //#endregion

          //#region  风险事件汇总
          {
            name: "market_events_summary",
            title: "风险事件汇总",
            navi: true,
            route: {
              path: "/market/events/summary",
              meta: {
                permissionOn: true,
                permissions: {
                  listedSentiment: [],
                },
              },
              component: () => import(/* webpackChunkName: "pages-product2" */ "../pages/product2/events/summary.vue"),
            },
          },
          //#endregion

          //#region  风险结果分析
          {
            name: "market_lc_result",
            title: "风险结果分析",
            navi: true,
            children: [
              {
                name: "market_lc_result_industry",
                title: "行业风险表现",
                navi: true,
                route: {
                  path: "/market/lc/result/industry",
                  meta: {
                    permissionOn: true,
                    permissions: {
                      lcResult: [],
                    },
                  },
                  component: () => import(/* webpackChunkName: "pages-product2" */ "../pages/product2/lc_result/industry.vue"),
                },
              },
              {
                name: "market_lc_result_company",
                title: "公司风险表现",
                navi: true,
                route: {
                  path: "/market/lc/result/company",
                  meta: {
                    permissionOn: true,
                    permissions: {
                      lcResult: [],
                    },
                  },
                  component: () => import(/* webpackChunkName: "pages-product2" */ "../pages/product2/lc_result/company.vue"),
                },
              },
              {
                name: "market_lc_result_target",
                title: "指标风险表现",
                navi: true,
                route: {
                  path: "/market/lc/result/target",
                  meta: {
                    permissionOn: true,
                    permissions: {
                      lcResult: [],
                    },
                  },
                  component: () => import(/* webpackChunkName: "pages-product2" */ "../pages/product2/lc_result/target.vue"),
                },
              },
              {
                name: "market_lc_result_esgranking",
                title: "ESG风险榜单",
                navi: true,
                route: {
                  path: "/market/lc/result/esgranking",
                  meta: {
                    permissionOn: true,
                    permissions: {
                      lcResult: [],
                    },
                  },
                  component: () => import(/* webpackChunkName: "pages-product2" */ "../pages/product2/lc_result/esgranking.vue"),
                },
              },
              {
                name: "market_lc_result_city",
                title: "城市ESG风险",
                navi: true,
                route: {
                  path: "/market/lc/result/city",
                  meta: {
                    permissionOn: true,
                    permissions: {
                      lcResult: [],
                    },
                  },
                  component: () => import(/* webpackChunkName: "pages-product2" */ "../pages/product2/lc_result/city.vue"),
                },
              },
            ],
          },
          //#endregion
        ],
      },
      //#endregion
      //#region 双碳榜单
      {
        name: "product3",
        title: "双碳榜单",
        stage: "product3",
        navi: true,
        route: {
          path: "/carbon",
          meta: {
            validation: true,
            permissionOn: true,
            permissions: {
              stageList: [],
            },
            stage: "product3",
          },
          redirect: { name: "carbon_target" },
          component: () => import(/* webpackChunkName: "pages-audit" */ "../pages/commons/Layout.vue"),
        },
        children: [
          //#region  基础管理
          {
            name: "carbon_basic",
            title: "基础管理",
            navi: true,
            children: [
              //#region  指标管理
              {
                name: "carbon_target",
                title: "指标管理",
                navi: true,
                route: {
                  path: "/carbon/target",
                  meta: {
                    permissionOn: true,
                    permissions: {
                      carbonTarget: [],
                    },
                  },
                  component: () => import(/* webpackChunkName: "pages-product3" */ "../pages/product3/target.vue"),
                },
                children: [
                  {
                    name: "carbon_target_edit",
                    title: "指标详情",
                    detail: true,
                    navi: { shown: false },
                    route: {
                      parentName: "product3",
                      path: "/carbon/target/detail/:year-:industryId-:thirdTargetNum",
                      meta: {
                        permissionOn: true,
                        permissions: {
                          carbonTarget: [],
                        },
                      },
                      component: () => import(/* webpackChunkName: "pages-product3" */ "../pages/product3/targetDetail.vue"),
                    },
                  },
                  {
                    name: "carbon_target_create",
                    title: "指标详情",
                    detail: true,
                    navi: { shown: false },
                    route: {
                      parentName: "product3",
                      path: "/carbon/target/detail/",
                      meta: {
                        permissionOn: true,
                        permissions: {
                          carbonTarget: [],
                        },
                      },
                      component: () => import(/* webpackChunkName: "pages-product3" */ "../pages/product3/targetDetail.vue"),
                    },
                  },
                ],
              },
              //#endregion

              //#region  公司管理
              {
                name: "carbon_company",
                title: "公司管理",
                navi: true,
                route: {
                  path: "/carbon/company",
                  meta: {
                    permissionOn: true,
                    permissions: {
                      carbonCompany: [],
                    },
                  },
                  component: () => import(/* webpackChunkName: "pages-product3" */ "../pages/product3/company.vue"),
                },
                children: [
                  {
                    name: "carbon_company_detail",
                    title: "公司详情",
                    detail: true,
                    navi: { shown: false },
                    route: {
                      parentName: "product3",
                      path: "/carbon/company/detail/:stockCode?",
                      meta: {
                        permissionOn: true,
                        permissions: {
                          carbonCompany: [],
                        },
                      },
                      component: () => import(/* webpackChunkName: "pages-product3" */ "../pages/product3/companyDetail.vue"),
                    },
                  },
                ],
              },
              //#endregion

              //#region  一票否决公司管理
              {
                name: "carbon_company_vote",
                title: "一票否决公司管理",
                navi: true,
                route: {
                  path: "/carbon/company/vote",
                  meta: {
                    permissionOn: true,
                    permissions: {
                      carbonCompanyVote: [],
                    },
                  },
                  component: () => import(/* webpackChunkName: "pages-product3" */ "../pages/product3/company/companyVote.vue"),
                },
              },
            ],
          },
          //#endregion

          //#region  报告库
          {
            name: "carbon_report",
            title: "报告库",
            navi: true,
            route: {
              path: "/carbon/report",
              meta: {
                permissionOn: true,
                permissions: {
                  carbonReport: [],
                },
              },
              component: () => import(/* webpackChunkName: "pages-product3" */ "../pages/product3/report.vue"),
            },
          },
          //#endregion

          //#region  数据录入
          {
            name: "+carbon_targetData",
            title: "数据录入",
            navi: true,
            children: [
              {
                name: "carbon_targetData_index",
                title: "录入概况",
                navi: true,
                route: {
                  path: "/carbon/targetData/index",
                  meta: {
                    permissions: {
                      carbonTargetData: [],
                    },
                  },
                  component: () => import(/* webpackChunkName: "pages-product3" */ "../pages/product3/targetData/index.vue"),
                },
              },
              {
                name: "carbon_targetData_input",
                title: "报告录入",
                navi: true,
                route: {
                  path: "/carbon/targetData/input",
                  meta: {
                    permissionOn: true,
                    permissions: {
                      carbonReport: [],
                    },
                  },
                  component: () => import(/* webpackChunkName: "pages-product3" */ "../pages/product3/targetData/input.vue"),
                },
              },
            ],
          },
          //#endregion

          //#region  数据管理
          {
            name: "carbon_targetData_manager",
            title: "数据管理",
            navi: true,
            route: {
              path: "/carbon/targetData/manager",
              meta: {
                permissionOn: true,
                permissions: {
                  carbonTargetData: [],
                },
              },
              component: () => import(/* webpackChunkName: "pages-product3" */ "../pages/product3/targetData/manager.vue"),
            },
            children: [],
          },
          //#endregion
          
          //#region  数据结果
          {
            name: "+carbon_result",
            title: "数据结果",
            navi: true,
            children: [
              {
                name: "carbon_result_ranking",
                title: "排行榜",
                navi: true,
                route: {
                  path: "/carbon/result/ranking",
                  meta: {
                    permissionOn: true,
                    permissions: {
                      carbonScore: [],
                    },
                  },
                  component: () => import(/* webpackChunkName: "pages-product3" */ "../pages/product3/result/ranking.vue"),
                },
              },
              {
                name: "carbon_result_firstTarget",
                title: "一级指标得分",
                navi: true,
                route: {
                  path: "/carbon/result/firstTarget",
                  meta: {
                    permissionOn: true,
                    permissions: {
                      carbonScore: [],
                    },
                  },
                  component: () => import(/* webpackChunkName: "pages-product3" */ "../pages/product3/result/firstTarget.vue"),
                },
              },
              {
                name: "carbon_result_history",
                title: "历史得分",
                navi: true,
                route: {
                  path: "/carbon/result/history",
                  meta: {
                    permissionOn: true,
                    permissions: {
                      carbonScore: [],
                    },
                  },
                  component: () => import(/* webpackChunkName: "pages-product3" */ "../pages/product3/result/history.vue"),
                },
              },
            ],
          },
          //#endregion
        ],
      },
      //#endregion
    ],
  },


  //#region  审核管理
  {
    name: "audit",
    title: "审核管理",
    stage: "audit",
    navi: true,
    route: {
      path: "/audit",
      meta: {
        validation: true,
        permissionOn: true,
        permissions: {
          stageAudit: [],
        },
        stage: "audit",
      },
      redirect: { name: "audit_task_pool" },
      component: () => import(/* webpackChunkName: "pages-audit" */ "../pages/commons/Layout.vue"),
    },
    children: [
      //#region  任务分配
      {
        name: "audit_task_pool",
        title: "任务分配",
        navi: true,
        route: {
          path: "task/pool",
          meta: {},
          component: () => import(/* webpackChunkName: "pages-product1" */ "../pages/task/completion.vue"),
        },
      },
      //#endregion

      //#region  完成情况
      {
        name: "audit_dashboard",
        title: "完成情况",
        navi: true,
        children: [
          {
            name: "audit_dashboard_product1",
            title: "榜单",
            navi: true,
            route: {
              path: "product1/dashboard",
              component: () => import(/* webpackChunkName: "pages-audit" */ "../pages/statistics/product1.vue"),
            },
          },
          {
            name: "audit_dashboard_product2",
            title: "上市公司舆情",
            navi: true,
            route: {
              path: "product2/dashboard",
              component: () => import(/* webpackChunkName: "pages-audit" */ "../pages/statistics/product2.vue"),
            },
          },
        ],
      },
      //#endregion

      //#region  数据审核
      {
        name: "audit_targetData_manager",
        title: "数据审核",
        navi: true,
        children: [
          {
            name: "+product1",
            title: "CSR调研",
            navi: {
              menuType: 2
            },
            children: [
              {
                name: "audit_product1_targetData_manager",
                title: "榜单指标数据",
                navi: true,
                route: {
                  path: "product1/targetData/manager",
                  component: () => import(/* webpackChunkName: "pages-audit" */ "../pages/product1/targetData/manager.vue"),
                },
                children: [],
              },
              {
                name: "audit_product1_sentiment_behavior",
                title: "负面行为数据",
                navi: true,
                route: {
                  path: "product1/sentiment/behavior",
                  component: () => import(/* webpackChunkName: "pages-audit" */ "../pages/product1/sentiment/behavior.vue"),
                },
                children: [],
              },
            ],
          },
          {
            name: "+product2",
            title: "ESG舆情风险",
            navi: {
              menuType: 2
            },
            children: [
              {
                name: "audit_product2_sentiment_negative",
                title: "上市公司社会舆情",
                navi: true,
                route: {
                  path: "/audit/product2/sentiment/negative",
                  component: () => import(/* webpackChunkName: "pages-audit" */ "../pages/product2/sentiment/negative.vue"),
                },
                children: [],
              },
              {
                name: "audit_product2_punishment",
                title: "上市公司行政处罚",
                navi: true,
                route: {
                  path: "/audit/product2/punishment",
                  component: () => import(/* webpackChunkName: "pages-audit" */ "../pages/product2/punishment/index.vue"),
                },
                children: [],
              },
            ],
          },
          {
            name: "+product3",
            title: "双碳调研",
            navi: {
              menuType: 2
            },
            children: [
              {
                name: "audit_carbon_targetData_manager",
                title: "榜单指标数据",
                navi: true,
                route: {
                  path: "/audit/carbon/targetData/manager",
                  component: () => import(/* webpackChunkName: "pages-audit" */ "../pages/product3/targetData/manager.vue"),
                },
                children: [],
              }
            ],
          },
        ],
      },
      //#endregion

      //#region  数据审核结果
      {
        name: "audit_data_result",
        title: "审核结果",
        navi: true,
        children: [
          {
            name: "audit_data_result_product1",
            title: "CSR调研",
            navi: {
              menuType: 2
            },
            children: [
              {
                name: "audit_result_ranking",
                title: "排行榜",
                navi: true,
                route: {
                  path: "result/ranking",
                  component: () => import(/* webpackChunkName: "pages-audit" */ "../pages/product1/result/ranking.vue"),
                },
              },
              {
                name: "audit_result_firstTarget",
                title: "一级指标得分",
                navi: true,
                route: {
                  path: "result/firstTarget",
                  component: () => import(/* webpackChunkName: "pages-audit" */ "../pages/product1/result/firstTarget.vue"),
                },
              },
              {
                name: "audit_result_history",
                title: "榜单历史得分",
                navi: true,
                route: {
                  path: "result/history",
                  component: () => import(/* webpackChunkName: "pages-audit" */ "../pages/product1/result/history.vue"),
                },
              },
            ],
          },
          {
            name: "audit_data_result_product2",
            title: "舆情",
            navi: {
              menuType: 2
            },
            children: [
              {
                name: "audit_lc_result_esgranking",
                title: "ESG风险榜单",
                navi: true,
                route: {
                  path: "lc/result/esgranking",
                  component: () => import(/* webpackChunkName: "pages-product2" */ "../pages/product2/lc_result/esgranking.vue"),
                },
              },
              {
                name: "audit_lc_result_target",
                title: "ESG行业风险指数",
                navi: true,
                route: {
                  path: "lc/result/target",
                  component: () => import(/* webpackChunkName: "pages-product2" */ "../pages/product2/lc_result/target.vue"),
                },
              },
              {
                name: "audit_lc_result_company",
                title: "公司ESG风险评级",
                navi: true,
                route: {
                  path: "lc/result/company",
                  component: () => import(/* webpackChunkName: "pages-product2" */ "../pages/product2/lc_result/company.vue"),
                },
              },
            ],
          },
          //双碳
          {
            name: "audit_data_result_product3",
            title: "双碳调研",
            navi: {
              menuType: 2
            },
            children: [
              {
                name: "audit_carbon_result_ranking",
                title: "双碳排行榜",
                navi: true,
                route: {
                  path: "carbon/result/ranking",
                  component: () => import(/* webpackChunkName: "pages-audit" */ "../pages/product3/result/ranking.vue"),
                },
              },
              {
                name: "audit_carbon_result_firstTarget",
                title: "一级指标得分",
                navi: true,
                route: {
                  path: "carbon/result/firstTarget",
                  component: () => import(/* webpackChunkName: "pages-audit" */ "../pages/product3/result/firstTarget.vue"),
                },
              },
              {
                name: "audit_carbon_result_history",
                title: "历史得分",
                navi: true,
                route: {
                  path: "carbon/result/history",
                  component: () => import(/* webpackChunkName: "pages-audit" */ "../pages/product3/result/history.vue"),
                },
              },
            ],
          },
        ],
      },
      //#endregion
    ],
  },
  //#endregion

  {
    name: "test",
    title: "非正式内容",
    route: {
      path: "/",
      component: () => import(/* webpackChunkName: "pages-audit" */ "../pages/commons/Layout.vue"),
    },
    children: [
      {
        name: "elements",
        title: "元素组件",
        route: {
          path: "/elements",
          component: () => import(/* webpackChunkName: "pages-login" */ "@/pages/Elements.vue"),
        },
      },
      {
        name: "dashboard",
        title: "面板",
        route: {
          path: "/dashboard",
          component: () => import(/* webpackChunkName: "pages-login" */ "@/pages/Dashboard.vue"),
        },
      },
      {
        name: "sitemap",
        title: "网站地图",
        route: {
          path: "/sitemap",
          name: "sitemap",
          meta: {
            permissionOn: false,
          },
          component: () => import(/* webpackChunkName: "pages" */ "@/pages/Sitemap.vue"),
        },
      },
    ]
  },
  {
    name: "storage_preview",
    title: "预览",
    route: {
      path: "/preview/:storageName",
      component: () => import(/* webpackChunkName: "pages-login" */ "@/pages/Preview.vue"),
    },
  },
  {
    name: "login",
    title: "登录",
    route: {
      path: "/auth/login",
      name: "login",
      component: () => import(/* webpackChunkName: "pages-login" */ "@/pages/Login.vue"),
    },
  },
  {
    name: "404",
    title: "找不到页面",
    route: {
      path: "*",
      component: () => import(/* webpackChunkName: "pages" */ "@/pages/Empty.vue"),
    },
  },
];
